/**
 * 全局核心公共组件
 */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import {
  createCode3Widget,
  isCsairApp,
  absoluteLayoutRestPage,
} from '@csair/emp-helpers';
import { codeExtLink } from 'utilsRecommendCode';
import { createWechatSdk } from 'Utils';
import {
  changeNavbarState,
  getSysConf,
  getAppConf,
  getMileageSwitch,
  getcustomerUrlSwitch,
} from '../../modules/actions';
import { selectTabStyle } from '../../routes/updateDetail/modules/actions';
import { getUserInfo, getLanguage } from '../../modules/actions';
import CustomerService from '../../../components/OnlineService';
import ReactDOM from 'react-dom';
import Cookies from 'js-cookie';
import cn from 'cn';
import en from 'en';
class AppContainer extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
  };

  constructor(props) {
    super(props);
  }
  componentWillMount() {
    window.CryptoJS = CryptoJS;
    const { selectTabStyle, location, getLanguage } = this.props;
    let lang = location.query.language;
    if (lang) {
      window.sessionStorage.setItem('language', lang);
      if (lang == 'en') {
        getLanguage(en);
        document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
      } else {
        getLanguage(cn);
      }
    } else {
      if (window.sessionStorage.getItem('language') == 'en') {
        getLanguage(en);
      } else {
        getLanguage(cn);
      }
    }
    this._getUserInfo();
    if (
      window.__wxjs_environment &&
      window.__wxjs_environment === 'miniprogram'
    ) {
      if (
        Cookies.get('TOKEN') === 'TOKEN' ||
        Cookies.get('TOKEN') === 'token' ||
        !Cookies.get('TOKEN')
      ) {
        if (location.query.token) {
          Cookies.remove('TOKEN');
          Cookies.remove('cs1246643sso');
          Cookies.remove('csmbplogintype');
          Cookies.set('TOKEN', location.query.token);
          Cookies.set('cs1246643sso', location.query.token);
          // Cookies.set('csmbplogintype', "6")
          Cookies.set('wxopenLogintype', 'fastlogin');
        }
      }
    }
    // 刷新，第一次进入程序重置退改列表tab的状态。
    if (location.query.selectTabStyle) {
      selectTabStyle(location.query.selectTabStyle);
    } else {
      selectTabStyle('1');
    }
    this._getConfig();
    this._getMileageSwitch();

    this._getcustomerUrlSwitch();
    window.H5NavigationBack = () => {
      return 'N';
    };
    // let vconsole = document.getElementById('__vconsole');
    // vconsole ? vconsole.style.display = 'none': '';
    // this._getUserInfo();
    // const memberNo = this.props.userInfo.memberNo;
    // if (
    //   [ '118218337593','149459309923'
    //   ].includes(
    //     memberNo
    //   )
    // ) {
    //   vconsole ? vconsole.style.display = 'block': '';
    // }
  }

  componentDidMount() {
    const { location, changeNavbarState } = this.props;
    const { channel } = location.query;
    // 判断是否是app入口
    if (
      location.query.t === 'fromClient' ||
      isCsairApp() ||
      (window.__wxjs_environment && window.__wxjs_environment === 'miniprogram')
    ) {
      changeNavbarState(false);
    }
    // setTimeout(this._getConfig, 2000);
    setTimeout(codeExtLink, 500);
    // 如果是小程序入口进入，加载微信jsdk
    ((window.__wxjs_environment &&
      window.__wxjs_environment === 'miniprogram') ||
      channel === 'wxopen') &&
      createWechatSdk();
    absoluteLayoutRestPage();
    // if (/(ReformProcess)|(ApplySubmit)|(TicketChange)|(selectDate)|(EndorsedApply)|(refundApply)/.test(window.location.href)) {
    //   const container = document.createElement('div');
    //   ReactDOM.render(<CustomerService />, container);
    //   const targetNode = document.getElementById('root');
    //   targetNode.appendChild(container);
    // }
    // window.addEventListener('visibilitychange', function () {
    //   if (window.sessionStorage.getItem('toggel')) {
    //     window.sessionStorage.removeItem('toggel')
    //     window.location.reload()
    //   }
    // });
  }

  _getUserInfo = async () => {
    await this.props.getUserInfo();
  };

  _getConfig = async () => {
    const { getSysConf, getAppConf } = this.props;
    await [createCode3Widget(), getAppConf(), getSysConf()];
  };

  _getMileageSwitch = async () => {
    const { getMileageSwitch } = this.props;
    await getMileageSwitch();
  };

  _getcustomerUrlSwitch = async () => {
    const { getcustomerUrlSwitch } = this.props;
    const switchData = await getcustomerUrlSwitch();
    let cs = 'N',
      at = 'N',
      ig = 'N';
    try {
      if (
        switchData.payload.data.kaiguan &&
        switchData.payload.data.kaiguan.length > 0
      ) {
        cs =
          switchData.payload.data.kaiguan.filter(
            i => i.business_type === 'S'
          )[0].is_open === '1'
            ? 'Y'
            : 'N';
        at =
          switchData.payload.data.kaiguan.filter(
            i => i.business_type === 'P'
          )[0].is_open === '1'
            ? 'Y'
            : 'N';
        ig =
          switchData.payload.data.kaiguan.filter(
            i => i.business_type === 'J'
          )[0].is_open === '1'
            ? 'Y'
            : 'N';
        window.sessionStorage.setItem('csSwitch', cs);
        window.sessionStorage.setItem('atSwitch', at);
        window.sessionStorage.setItem('igSwitch', ig);
      }
    } catch (error) {
      console.log('接口异常');
    }
  };

  render() {
    const { children } = this.props;
    return <React.Fragment>{children}</React.Fragment>;
  }
}

export default connect(
  state => ({
    userInfo: state.App.userInfo,
  }),
  dispatch => {
    return {
      selectTabStyle: index => dispatch(selectTabStyle(index)),
      changeNavbarState: bool => dispatch(changeNavbarState(bool)),
      getSysConf: data => dispatch(getSysConf(data)),
      getAppConf: () => dispatch(getAppConf()),
      getMileageSwitch: () => dispatch(getMileageSwitch()),
      getUserInfo: () => dispatch(getUserInfo()),
      getLanguage: data => dispatch(getLanguage(data)),
      getcustomerUrlSwitch: () => dispatch(getcustomerUrlSwitch()),
    };
  }
)(AppContainer);



// WEBPACK FOOTER //
// ./src/routes/containers/AppContainer/index.js